var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotifyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37262 0 0 5.37272 0 12C0 18.6277 5.37272 24 12 24C18.6278 24 24 18.6277 24 12C24 5.37319 18.6278 0.00065625 11.9998 0.00065625L11.9999 9.375e-05L12 0ZM17.503 17.3076C17.2881 17.6601 16.8266 17.7718 16.4741 17.5554C13.6567 15.8345 10.1099 15.4447 5.93288 16.399C5.73945 16.443 5.53646 16.4085 5.36854 16.3028C5.20061 16.1972 5.08149 16.0293 5.03737 15.8359C5.01539 15.7401 5.01251 15.641 5.02889 15.5441C5.04527 15.4473 5.0806 15.3546 5.13285 15.2714C5.1851 15.1882 5.25324 15.1161 5.33338 15.0593C5.41352 15.0025 5.50408 14.9621 5.59987 14.9403C10.1711 13.8959 14.092 14.3455 17.2552 16.2787C17.6077 16.495 17.7194 16.9551 17.503 17.3076ZM18.9718 14.0401C18.7009 14.4803 18.1249 14.6193 17.685 14.3484C14.4594 12.3658 9.54253 11.7916 5.72737 12.9497C5.23256 13.0991 4.71 12.8203 4.55981 12.3263C4.41075 11.8315 4.68975 11.3099 5.18372 11.1595C9.54169 9.83709 14.9595 10.4777 18.6638 12.7539C19.1036 13.0249 19.2427 13.6008 18.9718 14.0401ZM19.0979 10.6376C15.2303 8.34038 8.84944 8.12906 5.15691 9.24994C4.56394 9.42975 3.93684 9.09497 3.75722 8.502C3.5775 7.90875 3.91191 7.28212 4.50534 7.10184C8.74406 5.81503 15.7907 6.06375 20.2433 8.70712C20.7779 9.02362 20.9527 9.7125 20.636 10.2451C20.3208 10.7785 19.63 10.9543 19.0985 10.6376H19.0979Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyicon);
export default __webpack_public_path__ + "static/media/spotifyicon.975513cdcea1218e8b8170f8394db4f1.svg";
export { ForwardRef as ReactComponent };